import React from 'react';
import generateAttributes from "../../functions/generateAttributes";
import "../../styles/components/InsightCard.scss";

function InsightCard({ title, date, imageUrl, to, ...props }) {
    const attr = generateAttributes("InsightCard", props);

    // Robust date handling: accept ISO string or Date; format for display; avoid Invalid Date
    let displayDate = "";
    let dateTimeAttr;
    if (date) {
        const d = date instanceof Date ? date : new Date(date);
        if (!isNaN(d)) {
            displayDate = d.toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "2-digit",
            });
            dateTimeAttr = d.toISOString();
        } else {
            // Fallback: show the original value as plain text, omit dateTime
            displayDate = String(date);
        }
    }

    return (
        <a {...attr()} href={to} target="_blank" rel="noopener noreferrer">
            <div {...attr("imageContainer")}>
                {imageUrl && (
                    <img
                        {...attr("image")}
                        src={imageUrl}
                        alt={title}
                    />
                )}
            </div>
            <div {...attr("cardContent")}>
                <h3 {...attr("cardTitle")}>{title}</h3>
                {displayDate && (
                    <p {...attr("cardMeta")}>
                        <time dateTime={dateTimeAttr}>{displayDate}</time>
                    </p>
                )}
            </div>
        </a>
    );
}

export default InsightCard;
